// extracted by mini-css-extract-plugin
export var container = "contactteaser-module--container--45a32";
export var cta = "contactteaser-module--cta--b1f65";
export var image = "contactteaser-module--image--078be";
export var main = "contactteaser-module--main--c9c50";